module.exports = __webpack_public_path__ + "static/enterprise-9b8d5843551b4924b706b5f0e052b1ee.png";